<template>
  <div :class="{'card mgt-20px': !isChildRow}">
    <header class="header-card" v-if="!isChildRow">
      <p>{{ $t('addEditParution.pageParution.title')}}</p>
    </header>
    <div class="card-content" :class="{'pd-0': isChildRow}">
      <div v-if="!isDetail" class="columns is-marginless">
        <div class="column is-narrow">
          <selecteur-action
            :options="actions"
            :placeholder='$t("general.placeHolder.groupedAction")'
            :elementsSelectionnes="getAllSelected.length > 0"
            @handleAction="handleActions"
            titleButton="general.button.apply">
          </selecteur-action>
        </div>
        <div class="column has-text-right">
          <a @click="addPage()" class="button is-addOrEdit">
            {{ $t('addEditParution.actions.addPage')}}
          </a>
        </div>
      </div>
      <v-client-table
        :data="parution.pages"
        :columns="columns"
        :options="options"
        class="column is-12"
        ref="tabl ePagesParution">
        <div
          slot="selected"
          slot-scope="props"
          class="has-text-centered">
          <b-checkbox class="mgt-5px"
            v-model="props.row.selected"
            @input="updatePage(props.row, 'selected')"/>
        </div>
        <template slot="ordre" slot-scope="props">
          <b-input
            v-if="!isDetail"
            v-model.number="props.row.ordre"
            :use-html5-validation="false"
            @input="updatePage(props.row, 'ordre')"
            type="number">
          </b-input>
          <span v-else> {{ props.row.ordre }} </span>
        </template>
        <template slot="nom" slot-scope="props">
          <b-input
            v-if="!isDetail"
            v-model="props.row.nom"
            :use-html5-validation="false"
            @input="updatePage(props.row, 'nom')">
          </b-input>
          <span v-else> {{ props.row.nom }} </span>
        </template>
        <template slot="largeurUtile" slot-scope="props">
          <b-input
            v-if="!isDetail"
            v-model.number="props.row.largeurUtile"
            :use-html5-validation="false"
            @input="updatePage(props.row, 'largeurUtile')"
            type="number"
            min="0">
          </b-input>
          <span v-else> {{ props.row.largeurUtile }} </span>
        </template>
        <template slot="hauteurUtile" slot-scope="props">
          <b-input
            v-if="!isDetail"
            v-model.number="props.row.hauteurUtile"
            :use-html5-validation="false"
            @input="updatePage(props.row, 'hauteurUtile')"
            type="number"
            min="0">
          </b-input>
          <span v-else> {{ props.row.hauteurUtile }} </span>
        </template>
        <template slot="largeur" slot-scope="props">
          <b-input
            v-if="!isDetail"
            v-model.number="props.row.largeur"
            :use-html5-validation="false"
            @input="updatePage(props.row, 'largeur')"
            type="number"
            min="0">
          </b-input>
          <span v-else> {{ props.row.largeur }} </span>
        </template>
        <template slot="hauteur" slot-scope="props">
          <b-input
            v-if="!isDetail"
            v-model.number="props.row.hauteur"
            :use-html5-validation="false"
            @input="updatePage(props.row, 'hauteur')"
            type="number"
            min="0">
          </b-input>
          <span v-else> {{ props.row.hauteur }} </span>
        </template>
        <template slot="margeGauche" slot-scope="props">
          <b-input
            v-if="!isDetail"
            v-model.number="props.row.margeGauche"
            :use-html5-validation="false"
            @input="updatePage(props.row, 'margeGauche')"
            type="number"
            min="0">
          </b-input>
          <span v-else> {{ props.row.margeGauche }} </span>
        </template>
        <template slot="margeHaute" slot-scope="props">
          <b-input
            v-if="!isDetail"
            v-model.number="props.row.margeHaute"
            :use-html5-validation="false"
            @input="updatePage(props.row, 'margeHaute')"
            type="number"
            min="0">
          </b-input>
          <span v-else> {{ props.row.margeHaute }} </span>
        </template>
        <template slot="emplacementId" slot-scope="props">
          <parametre-autocomplete
            v-if="!isDetail"
            v-model="props.row.emplacementId"
            :target="constantes.PARAMETRES_KEYS.emplacementPresse"
            expanded
            @input="updatePage(props.row, 'emplacementId')"
         />
          <span v-else> {{ getLibelleInListe(props.row.emplacementId, emplacements) }} </span>
        </template>
        <template slot="surfaceId" slot-scope="props">
          <b-select
            v-if="!isDetail"
            v-model="props.row.surfaceId"
            @input="updatePage(props.row, 'surfaceId')"
            expanded>
            <option
              v-for="item in surfaces"
              :key="item.id"
              :value="item.id">
              {{ item.libelle }}
            </option>
          </b-select>
          <span v-else> {{ getLibelleInListe(props.row.surfaceId, surfaces) }} </span>
        </template>
        <template slot="couleurEncartId" slot-scope="props">
          <parametre-autocomplete
            v-if="!isDetail"
            v-model="props.row.couleurEncartId"
            :target="constantes.PARAMETRES_KEYS.couleurEncart"
            @input="updatePage(props.row, 'couleurEncartId')"
            field="libelle"
            expanded
          />
          <span v-else> {{ getLibelleInListe(props.row.couleurEncartId, couleurEncarts) }} </span>
        </template>
        <template slot="delete" slot-scope="props">
          <a @click="deletePage(props.row.id)">
            <b-icon icon="delete-forever" class="mgt-5px" type="is-danger"/>
          </a>
        </template>
      </v-client-table>
    </div>
    <b-modal
      v-model="popUpShow"
      class="modal"
      has-modal-card
      @close="currentComponentPopUp = ''">
      <component
        :is="currentComponentPopUp"
        :items="getAllSelected"
        :parution="parution"
        :emplacements="emplacements"
        :surfaces="surfaces"
        :couleur-encarts="couleurEncarts">
      </component>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import selecteurAction from '@/components/general/selecteurAction';
import PopUpDuplication from '@/components/presse/parution/edition/p_duplicationPage';
import PopUpModification from '@/components/presse/parution/edition/p_modificationPage';
import { ACTION_DELETE, ACTION_DUPLICATION } from '@/configuration/general/actionsConf';
import { ACTION_MASS_MODIFICATION } from '@/configuration/presse/parution/parutionConfig';
import genererPageParution from '@/services/presse/parution/genererPageParution';
import ParametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    parution: {
      type: Object,
      required: true,
    },
    produit: {
      type: Object,
      required: false,
      default: null,
    },
    isDetail: {
      type: Boolean,
    },
    isChildRow: {
      type: Boolean,
    },
  },
  components: {
    ParametreAutocomplete,
    selecteurAction,
    PopUpDuplication,
    PopUpModification,
  },
  data() {
    return {
      actions: [
        { action: ACTION_MASS_MODIFICATION, translation: 'addEditParution.pageParution.actions.modifications' },
        { action: ACTION_DUPLICATION, translation: 'addEditParution.pageParution.actions.dupliquer' },
        { action: ACTION_DELETE, translation: 'addEditParution.pageParution.actions.delete' },
      ],
      popUpShow: false,
      currentComponentPopUp: '',
      constantes: {
        PARAMETRES_KEYS: typesParametres.PARAMETRES_KEYS,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    getAllSelected() {
      return this.parution.pages.filter((el) => el.selected);
    },
    iconSelectTotal() {
      if (this.allSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    allSelected() {
      return this.getAllSelected.length === this.parution.pages.length
        && this.parution.pages.length > 0;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          ordre: this.$t('addEditParution.pageParution.ordre'),
          nom: this.$t('addEditParution.pageParution.nom'),
          largeurUtile: this.$t('addEditParution.pageParution.largeurUtile'),
          hauteurUtile: this.$t('addEditParution.pageParution.hauteurUtile'),
          largeur: this.$t('addEditParution.pageParution.largeur'),
          hauteur: this.$t('addEditParution.pageParution.hauteur'),
          margeGauche: this.$t('addEditParution.pageParution.margeGauche'),
          margeHaute: this.$t('addEditParution.pageParution.margeHaute'),
          surfaceId: this.$t('addEditParution.pageParution.surface'),
          emplacementId: this.$t('addEditParution.pageParution.emplacement'),
          couleurEncartId: this.$t('addEditParution.pageParution.couleurEncart'),
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          selected: 'colonneSelected',
          delete: 'colonneSelected',
        },
        sortable: ['surfaceId', 'emplacementId', 'couleurEncartId', 'nom', 'ordre', 'largeurUtile', 'hauteurUtile', 'largeur', 'hauteur', 'margeGauche', 'margeHaute'],
      };
    },
    columns() {
      const tab = ['selected', 'surfaceId', 'emplacementId', 'couleurEncartId', 'nom', 'ordre', 'largeurUtile', 'hauteurUtile', 'largeur', 'hauteur', 'margeGauche', 'margeHaute', 'delete'];
      if (this.isDetail) {
        tab.splice(0, 1);
        tab.splice(11, 1);
      }
      return tab;
    },
    emplacements() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.emplacementPresse);
    },
    surfaces() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.surface);
    },
    couleurEncarts() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.couleurEncart);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    selectAll() {
      const selected = !this.allSelected;
      this.parution.pages.forEach((el) => {
        el.selected = selected;
      });
    },
    addPage() {
      const newPage = genererPageParution(this.parution.pages.length + 1);
      if (this.produit && this.produit.produitPresse) {
        newPage.largeurUtile = this.produit.produitPresse.largeurFormatUtile;
        newPage.hauteurUtile = this.produit.produitPresse.hauteurFormatUtile;
        newPage.largeur = this.produit.produitPresse.largeurPleinPapier;
        newPage.hauteur = this.produit.produitPresse.hauteurPleinPapier;
        newPage.margeGauche = this.produit.produitPresse.margeGauche;
        newPage.margeHaute = this.produit.produitPresse.margeHaut;
      }
      this.parution.pages.push(newPage);
    },
    updatePage(row, key) {
      const find = this.parution.pages.find(el => el.id === row.id);
      if (find) this.$set(find, key, row[key]);
    },
    deletePage(id) {
      const index = this.parution.pages.findIndex(el => el.id === id);
      this.parution.pages.splice(index, 1);
    },
    getLibelleInListe(id, liste) {
      const find = liste.find(el => el.id === id);
      if (find) return find.libelle;
      return '';
    },
    handleActions(action) {
      switch (action) {
        case ACTION_DELETE:
          this.parution.pages = this.parution.pages
            .filter(p => !p.selected);
          break;
        case ACTION_DUPLICATION:
          this.popUpShow = true;
          this.currentComponentPopUp = 'pop-up-duplication';
          break;
        case ACTION_MASS_MODIFICATION:
          this.popUpShow = true;
          this.currentComponentPopUp = 'pop-up-modification';
          break;
        default:
          break;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.emplacementPresse,
        typesParametres.PARAMETRES_KEYS.surface,
        typesParametres.PARAMETRES_KEYS.couleurEncart,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
